import React from 'react';
interface AppBadgeProps {
  children: ReactNode;
  variant?: 'blue' | 'purple' | 'green' | 'amber' | 'rose' | 'gray';
  icon?: ReactNode;
  className?: string;
}
export function AppBadge({
  children,
  variant = 'gray',
  icon,
  className = ''
}: AppBadgeProps) {
  const variantClasses = {
    blue: 'bg-blue-50 text-blue-700',
    purple: 'bg-purple-50 text-purple-700',
    green: 'bg-green-50 text-green-700',
    amber: 'bg-amber-50 text-amber-700',
    rose: 'bg-rose-50 text-rose-700',
    gray: 'bg-gray-100 text-gray-700'
  };
  return <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${variantClasses[variant]} ${className}`} data-id="element-65">
      {icon && <span className="mr-1 -ml-0.5" data-id="element-66">{icon}</span>}
      {children}
    </span>;
}